import React from "react";
import { FormButton } from "../../../components/Button/Buttons";
import { MdInfo } from "react-icons/md";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as authActions from "../../../store/actions/auth";
import { constants } from "../../../constants";

const Login = (props) => {
  const { errors, register, handleSubmit } = useForm();
  const { error, loading } = props;
  const history = useHistory();

  const handleForm = (data, e) => {
    e.preventDefault();
    props.login(data, history);
  };

  return (
    <div className="flex items-center flex-col bg-primary h-screen">
      <div className="mt-16 lg:mt-24">
        <img
          src={constants.logo}
          alt="2gethr Logo"
          className="h-6 w-18 lg:h-8 lg:w-24"
        />
      </div>
      <div className="my-3 text-center">
        <h4 className="text-black font-display font-bold text-4xl">
          Admin Login
        </h4>
      </div>
      <div className="w-full max-w-md mt-6 shadow-lg p-6 bg-white rounded-lg">
        <form onSubmit={handleSubmit(handleForm)}>
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="w-full px-3">
              <label
                className="block uppercase tracking-wide text-black font-display text-xs font-bold mb-2"
                htmlFor="authKey"
              >
                Phone Number / Email ID
              </label>
              <input
                className={classNames({
                  "appearance-none block w-full bg-white font-display text-gray-700 border border-gray-400 rounded-sm py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500": true,
                  "border border-red-500":
                    errors.authKey && errors.authKey.message,
                })}
                id="authKey"
                // type="password"
                placeholder="Phone Number / Email"
                name="authKey"
                ref={register({
                  required: "Phone Number / Email is a required field.",
                })}
              />
              <div className="flex flex-row-reverse">
                <span className="text-red-600 text-sm">
                  {errors.authKey && errors.authKey.message}
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="w-full px-3">
              <label
                className="block uppercase tracking-wide font-display text-black text-xs font-bold mb-2"
                htmlFor="password"
              >
                Password
              </label>
              <input
                className={classNames({
                  "appearance-none block w-full bg-white font-display text-gray-700 border border-gray-400 rounded-sm py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500": true,
                  "border border-red-500":
                    errors.password && errors.password.message,
                })}
                id="password"
                type="password"
                placeholder="******************"
                name="password"
                ref={register({ required: "Password is a required field." })}
              />
              <div className="flex flex-row-reverse">
                <span className="text-red-600 text-sm">
                  {errors.password && errors.password.message}
                </span>
              </div>
            </div>
          </div>

          <FormButton disabled={loading} type="submit">
            Login
          </FormButton>
        </form>
        {/* Errors */}
        {error && (
          <div className="p-6 rounded-lg bg-red-500 flex space-x-4 items-center">
            <MdInfo color="#FFFFFF" size={24} />
            <h3 className="text-white text-center text-xl ">{error}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
  isAuthenticated: state.auth.isAuthenticated,
});

function mapDispatchToProps(dispatch) {
  const login = authActions.adminLogin.request;
  return bindActionCreators({ login }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
